if (!customElements.get('grise-gift-bag')) {
  customElements.define('grise-gift-bag', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const form = this.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button');
        if (button.disabled) return;
        const error = form.querySelector('[role="alert"]');
        const label = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Pridedama…';
        error.hidden = true;
        try {
          const drawer = this.closest('cart-drawer');
          const data = new FormData(form);
          data.delete('return_to');
          if (drawer) {
            data.append('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
            data.append('sections_url', window.location.pathname);
            drawer.setActiveElement(button);
          }
          const response = await fetch(form.action + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Nepavyko pridėti maišelio. Bandyk dar kartą.');
          if (drawer) {
            try {
              drawer.renderContents(result);
              const message = drawer.querySelector('grise-gift-bag');
              if (message) { message.setAttribute('tabindex', '-1'); message.focus(); }
            } catch (_) { window.location.assign(window.Shopify.routes.root + 'cart'); }
          } else {
            window.location.assign(window.Shopify.routes.root + 'cart');
          }
        } catch (issue) {
          error.textContent = issue.message || 'Nepavyko pridėti maišelio. Bandyk dar kartą.';
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = label;
        }
      });
    }
  });
}
